import type { EmailSearchRequest, EmailSearchResponse } from '@/types/emailSearch'
import { getAuth } from 'firebase/auth'

export class EmailSearchRepository {
  private baseUrl = `${import.meta.env.VITE_CF_BASE_URL}/SEARCH_EMAILS`

  private async getAuthToken(): Promise<string> {
    const user = getAuth().currentUser
    if (!user) throw new Error('Usuario no autenticado')
    return user.getIdToken()
  }

  /**
   * `signal` no es opcional en la práctica: sin cancelar la búsqueda anterior, al
   * teclear rápido las respuestas vuelven fuera de orden y una búsqueda vieja pisa
   * los resultados de la nueva.
   */
  async search(request: EmailSearchRequest, signal?: AbortSignal): Promise<EmailSearchResponse> {
    const token = await this.getAuthToken()
    const response = await fetch(this.baseUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(request),
      signal
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Error de conexión con el servidor' }))
      throw new Error(errorData.error || `Error ${response.status} al buscar correos`)
    }

    const result: EmailSearchResponse = await response.json()
    if (!result.success) throw new Error((result as any).error || 'Error en la respuesta del servidor')
    return result
  }
}
